import { requests } from '../../../../utils';
import {
    MEASURE_INFLUENCERS,
    MEASURE_INFLUENCERS_DATA,
    MEASURE_PLATFORMS,
    MEASURE_PLATFORMS_DATA,
    MEASURE_REPORT_POST,
    MEASURE_REVIEW,
    MEASURE_URL,
} from '../../../../utils/endpoints';
import { IReview } from '../../../../model/measure/IReview';
import { IReportItem } from '../../../../model/measure/IReportItem';
import { IKPI } from '../../../../model/measure/IMeasure';

export const MeasureService = {
    getMeasureFeedback: (id: number) => requests.get(`${MEASURE_URL}/feedback/${id}`),
    getSummaryData: (id: number) => requests.get(`${MEASURE_URL}/${id}`),
    getPlatforms: (id: number) => requests.get(`${MEASURE_PLATFORMS}/${id}`),
    getPlatformData: (params: any, id: number) => requests.get(`${MEASURE_PLATFORMS_DATA}/${id}`, params),
    getInfluencers: (id: number) => requests.get(`${MEASURE_INFLUENCERS}/${id}`),
    getInfluencersData: (params: any, id: number) => requests.get(`${MEASURE_INFLUENCERS_DATA}/${id}`, params),
    leaveReview: (body: IReview): Promise<IReview> => requests.post(`${MEASURE_REVIEW}`, body),
    getReportPost: (id: number): Promise<IReportItem> => requests.get(`${MEASURE_REPORT_POST}/${id}`),
    putMeasureKPI: (id: number, data: { kpi?: IKPI[] }) => requests.put(`${MEASURE_URL}/additional/kpi/${id}`, data),
};
